import React, { useState } from 'react';
import axios from 'axios';
import { Phone, Mail, Calendar, StickyNote, Plus, Loader2, Trash2 } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import { formatDate } from '../../crmConstants';

const API = process.env.REACT_APP_BACKEND_URL;

const NOTE_TYPES = [
  { id: 'general', label: 'Note', icon: StickyNote },
  { id: 'call', label: 'Call', icon: Phone },
  { id: 'email', label: 'Email', icon: Mail },
  { id: 'meeting', label: 'Meeting', icon: Calendar },
];

export const DealNotesTab = ({ dealId, notes, onRefresh }) => {
  const [newNote, setNewNote] = useState('');
  const [noteType, setNoteType] = useState('general');
  const [submitting, setSubmitting] = useState(false);

  const addNote = async () => {
    if (!newNote.trim()) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/admin/deals/${dealId}/notes`, { content: newNote, note_type: noteType }, { withCredentials: true });
      setNewNote('');
      onRefresh();
    } catch (err) {
      console.error('Failed to add note:', err);
    }
    setSubmitting(false);
  };

  const deleteNote = async (noteId) => {
    try {
      await axios.delete(`${API}/api/admin/deals/${dealId}/notes/${noteId}`, { withCredentials: true });
      onRefresh();
    } catch (err) {
      console.error('Failed to delete note:', err);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {/* Add Note */}
      <div style={{ background: '#FAFBFC', borderRadius: 8, padding: '1rem', border: '1px solid #E5E7EB' }}>
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
          {NOTE_TYPES.map(type => (
            <button
              key={type.id}
              onClick={() => setNoteType(type.id)}
              style={{
                padding: '0.375rem 0.625rem', borderRadius: 4, fontSize: '0.7rem', fontWeight: 500,
                border: noteType === type.id ? '1px solid var(--teal)' : '1px solid #E5E7EB',
                background: noteType === type.id ? 'rgba(13,148,136,0.1)' : '#fff',
                color: noteType === type.id ? 'var(--teal)' : '#6B7280',
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.25rem',
              }}
            >
              <type.icon size={12} /> {type.label}
            </button>
          ))}
        </div>
        <textarea
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder="Add a note..."
          data-testid="note-input"
          rows={3}
          style={{
            width: '100%', padding: '0.5rem', borderRadius: 6, border: '1px solid #E5E7EB',
            fontSize: '0.875rem', color: 'var(--navy)', resize: 'vertical', fontFamily: 'var(--font-body)',
          }}
        />
        <Button onClick={addNote} disabled={submitting || !newNote.trim()} className="btn-primary" style={{ marginTop: '0.5rem' }}>
          {submitting ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />}
          Add Note
        </Button>
      </div>

      {/* Notes List */}
      {notes.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '1rem' }}>No notes yet</p>
      ) : notes.map(note => {
        const typeConfig = NOTE_TYPES.find(t => t.id === note.note_type) || NOTE_TYPES[0];
        return (
          <div key={note.id} style={{
            padding: '0.875rem', borderRadius: 8, background: '#fff', border: '1px solid #E5E7EB',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <typeConfig.icon size={14} style={{ color: 'var(--teal)' }} />
                <span style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--navy)' }}>{note.author_name}</span>
                <span style={{ fontSize: '0.7rem', color: '#9CA3AF' }}>{formatDate(note.created_at, true)}</span>
              </div>
              <button onClick={() => deleteNote(note.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF' }}>
                <Trash2 size={14} />
              </button>
            </div>
            <p style={{ fontSize: '0.875rem', color: '#4B5563', margin: 0, whiteSpace: 'pre-wrap' }}>{note.content}</p>
          </div>
        );
      })}
    </div>
  );
};
